import { z } from 'zod'
import { makeFieldKeys } from '../../core/utils/utilities.ts'

export const MenuItemModelSchema = z
  .object({
    id: z.string(),
    menu_category_id: z.string(),
    key: z.string(),
    name: z.string(),
    icon: z.string(),
    href: z.string(),
    default: z.boolean(),
    sequence: z.number(),
    // Per-user gate: the cfg.menu_item_visibility_rules KEY, or null for the
    // items that have no rule (which is every pre-existing one). The RPC
    // deliberately does not filter on it — its payload is cached per backend
    // process and shared across users — so the evaluation lives in
    // filterMenuDataForDisplay. Nullable AND optional: the field is absent
    // until the RPC migration is applied.
    visibility_rule: z.string().nullable().optional()
  })
  .strict()

const MenuItemModelFields = makeFieldKeys(MenuItemModelSchema)

export type MenuItemModel = z.infer<typeof MenuItemModelSchema>
